module.exports = __webpack_public_path__ + "img/20.1c3c07de.png";